import type { Action } from '@unifyapps/defs/types/action';
import { useAdaptFileUrl } from '@unifyapps/network/hooks/useAdaptFileUrl';
import { useCallback } from 'react';
import { downloadFileInSameTab } from '../../../../../utils/file/downloadFileInSameTab';
import type { OnActionArgs, OnActionType } from '../../../../context/ActionsProvider/context';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

const useDownloadFile = () => {
  const { getNoCodeComputedData } = useGetNoCodeComputedData();
  const adaptFileUrl = useAdaptFileUrl();

  const onDownloadFile: OnActionType = useCallback(
    async (args: OnActionArgs) => {
      if (!args || !args.action || !args.action.payload) {
        return SHOULD_NOT_PROPAGATE_UP;
      }

      const computedAction = getNoCodeComputedData<Action>(
        args.action as unknown as Record<string, unknown>,
        args.actionContext,
      );

      const { url, fileName } = computedAction.payload as { url: string; fileName?: string };
      const adaptedUrl = adaptFileUrl(url, { preview: false });
      if (!adaptedUrl) {
        console.error('Invalid URL');
        return SHOULD_NOT_PROPAGATE_UP;
      }
      await Promise.resolve();
      try {
        downloadFileInSameTab(adaptedUrl, fileName);
      } catch (error) {
        console.error(error);
        return SHOULD_NOT_PROPAGATE_UP;
      }
      return SHOULD_NOT_PROPAGATE_UP;
    },
    [getNoCodeComputedData, adaptFileUrl],
  );

  return { onDownloadFile };
};

export default useDownloadFile;
